<template>
<!--    <router-view  v-if="!check && !showLogo && isConnected"/>-->
  <router-view/>


     
    <div v-if="check" class="modal-overlay-timer">
      <div class="modal-box timer-modal">
        <div class="modal-header">
          <img style="width: 3vw !important; margin-bottom: 0.5vw!important;"  src="/assets/media/logo3.png" alt="سامانه جامع و یکپارچه بهفام" class="logo-image">
          <p style="font-size: 0.9vw;margin: 0;">بروزرسانی جدیدی از نسخه فعلی سامانه منتشر شد</p>
        </div>
        <div class="modal-body">
          <p style="font-size: 0.8vw;">کاربر گرامی جهت بهبود عملکرد و دریافت آخرین تغییرات سامانه</p>
           <p style="color:#0d6fab;">لظفا نسبت به بروزرسانی سامانه اقدام نمایید</p>
          <p style="font-size: 0.8vw;color: #a7a2a2;">با تشکر از همراهی شما</p>
          <p style="font-size: 0.8vw;margin-top: -0.8vw;color: #a7a2a2;">تیم توسعه و پشتبانی سامانه جامع و یکپارچه بهفام</p>
        </div>
        <div class="modal-buttons">
          <button 
 style="background: #20a1f1;color:white ;font-size: 0.8vw;" 
 class="btn btn-approve"
 :disabled="updating"
 @click="submitChange">

{{ updating ? 'در حال بروزرسانی سامانه ...' : 'بروزرسانی سامانه' }}

</button>
        </div>
      </div>
    </div>

  

  
<!--  <HomeWaiting v-if="showLogo"/>-->
  <HomeWaitingTryagain v-if="!isConnected && !showLogo"/>
</template>
<script>
import {useToast} from "vue-toastification";
import BackIcon from "@/components/Icons/BackIcon.vue";
import HomeWaiting from "@/components/Loaders/HomeWaiting.vue";
import HomeWaitingTryagain from "@/components/Loaders/HomeWaitingTryagain.vue";

const toast = useToast();

export default {
  components: {HomeWaitingTryagain, HomeWaiting, BackIcon},
  data() {
    return {
      check: false,
      showLogo: true, // حالت اولیه نمایش لوگو
      isConnected: true, // حالت اولیه نمایش لوگو
    registration: null,
    updating:false,
    }
  },

  methods: {
    
  submitChange() {

    this.updating = true;

  if (this.registration && this.registration.waiting) {

    this.registration.waiting.postMessage({
      type: "SKIP_WAITING"
    });

    setTimeout(() => {
      window.location.reload();
    }, 1000);

  }

},


    checkServerConnection() {
      fetch(`${this.base_url}/health-check`, {method: 'GET'})
          .then(response => {
            if (response.ok) {
              this.isConnected = true;
            } else {
              throw new Error('Failed to connect');
            }
          })
          .catch(() => {
            this.isConnected = false;
            toast.error("ارتباط با سرور برقرار نشد.");
          })
          .finally(() => {
            if (this.isConnected) {
              setTimeout(() => {
                this.showLogo = false;
              }, 3000);
            } else {
              this.showLogo = false; // مخفی کردن لوگو در صورت قطع ارتباط
            }
          });
    }
  },
  created() {

  this.checkServerConnection();


  window.addEventListener("swUpdated", (event) => {

   

    this.registration = event.detail;
    this.check = true;

    document.body.style.overflowY = "hidden";

  });


  navigator.serviceWorker.addEventListener("controllerchange", () => {

    

    window.location.reload();

  });

if ('serviceWorker' in navigator) {

  const checkServiceWorkerUpdate = async () => {

    try {

      const registration = await navigator.serviceWorker.getRegistration();

      if (registration) {

      

        await registration.update();

      }

    } catch (error) {

     

    }

  };


  // 1) چک فوری هنگام ورود به سایت
  checkServiceWorkerUpdate();


  // 2) چک هر 30 ثانیه
  setInterval(() => {

    checkServiceWorkerUpdate();

  }, 30 * 1000);


  // 3) چک هنگام برگشت کاربر به تب سایت
  document.addEventListener("visibilitychange", () => {

    if (document.visibilityState === "visible") {

      

      checkServiceWorkerUpdate();

    }

  });

}

}
}

</script>


<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  direction: rtl !important;
}

.modal-overlay-timer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(6 34 74 / 97%);
  z-index: 999999999999999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-box {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 23vw;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}
.modal-buttons {
  display: flex;
  justify-content: space-around;
  background: #e1e1e1;
    padding: 1vw;
    border-radius: 0.5vw
  
}


.timer-modal {
  width: 30vw;
  border: 2px solid#087425;
  box-shadow: 0 0 15px rgba(220, 53, 69, 0.5);
}

.timer-modal .modal-header {
  color: #087425;
    border-bottom: 1px solid #087425;
    justify-content: center !important;
    margin: 0 !important;
    padding: 0;
    flex-direction: column;
    background: #1370441c;
    padding: 0.5vw;
}

/* استایل متن مودال */
.timer-modal .modal-body p {
  margin: 10px 0;
  text-align: center;
  font-size: 0.9vw;
  color: #333;
}


nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.modal__error {
  width: 30vw;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 1.3vw;
  padding: 1.1vw;
  box-shadow: 0 0 3px 2px #eee;
  background-color: #eceded;
  border: 0.1vw solid;

  & > div:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > p {

      font-size: 1.1vw;

      &:nth-child(2) {
        cursor: pointer;
      }

    }
  }

  & > div:last-child {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    & > p {
      font-size: 1.1vw;


    }

    & > button {
      font-size: 1vw;
      width: 8vw;
      background-color: #3742FA;
      color: #fff;
      border: unset;
      border-radius: .5vw;
      height: 2vw;
      margin-top: 2.5vw;
      margin-bottom: 2.5vw;
      cursor: pointer;


    }
  }
}

.blur {
  background-color: rgba(#222, 0.8);
  width: 100%;
  z-index: 9999999999 !important;
  height: 100vh;
  position: absolute;
  top: 0;
}
</style>
